import { assetworksData } from "game-layers";
import { GamingRealms } from "gaming-realms/gaming-realms";
import { EJSetup } from "setup/ej-setup";

GamingRealms.go(new EJSetup(), assetworksData, "/slingo/luckyjoker/games/");
